export default function TrustSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Users',
      description: 'All users are verified with ID and background checks for your peace of mind'
    },
    {
      icon: 'ri-lock-line',
      title: 'Secure Payments',
      description: 'Bank-level encryption protects your payments and personal information'
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Host Protection Policy',
      description: 'Comprehensive protection for hosts against property damage and liability claims'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Support',
      description: 'Our dedicated support team is here to help you'
    },
    {
      icon: 'ri-star-line',
      title: 'Trusted Reviews',
      description: 'Read genuine reviews from real users to make informed decisions'
    },
    {
      icon: 'ri-refund-line',
      title: 'Money-Back Guarantee',
      description: 'Full refund if your booking doesn\'t meet our quality standards'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Trust & Safety First
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Your security and peace of mind are our top priorities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
          </div>
          <div className="text-center">
          </div>
          <div className="text-center">
          </div>
        </div>
      </div>
    </section>
  );
}
